import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';

const SearchHeader = ({ onSearch, isLoading }) => {
    const [query, setQuery] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        if (query.trim() && !isLoading) {
            onSearch(query.trim());

            // Reset du scroll global lors d'une nouvelle recherche
            window.scrollTo({ top: 0, behavior: 'instant' });
        }
    };

    return (
        <div className="border border-5 border-secondary bg-secondary shadow-sm mb-4">
            <div className="row align-items-center g-0 p-2">

                {/* TITRE */}
                <div className="col-md-8 d-flex align-items-center text-white">
                    <i className="fa fa-shield fa-2x me-3 text-primary"></i>
                    <h4 className="mb-0 fw-bold text-nowrap">
                        E-LIFT<span className="text-white-50 fw-normal mx-2">|</span>
                        <span className="fs-5 text-uppercase">Audit</span>
                    </h4>
                </div>

                {/* RECHERCHE */}
                <div className="col-md-4">
                    <Form onSubmit={handleSubmit}>
                        <InputGroup size="sm" className="rounded overflow-hidden">
                            <InputGroup.Text className="bg-white border-0 ps-2">
                                <i className="fa fa-search text-muted opacity-50"></i>
                            </InputGroup.Text>

                            <Form.Control
                                placeholder="RECHERCHER UN BOOKING (EX: BK7890)..."
                                value={query}
                                onChange={(e) => setQuery(e.target.value.toUpperCase())}
                                className="border-0 shadow-none py-2 text-uppercase small"
                                disabled={isLoading}
                                style={{
                                    color: '#495057',
                                    fontWeight: query ? 'bold' : 'normal'
                                }}
                            />

                            <Button
                                variant="primary"
                                type="submit"
                                disabled={isLoading || !query.trim()}
                                className="px-3 fw-bold rounded-0 border-0 small"
                            >
                                {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "RECHERCHER"}
                            </Button>
                        </InputGroup>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default SearchHeader;